<template>
  <div id="app">
    <v-app> 
      <v-main class="bg-blue-grey-lighten-4">
        <router-view></router-view>
      </v-main>
    </v-app>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  components: {
  },
  data() {
    return {

    }
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

/* This will apply globally and override Vuetify styles
.v-app-bar.transparent-navbar,
.v-app-bar.transparent-navbar .v-toolbar__content,
.v-app-bar.transparent-navbar .v-toolbar__extension {
  background: transparent !important;
  background-color: transparent !important;
} */

@media (max-width: 600px) {
  .overview, .admin{
    display: none;
  }

}

</style>
